export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/animated_gifs.b88de6a.svg";